import { formatCurrency, formatPhoneNumber } from 'helpers/formatData'
import { formatSSN } from 'helpers/formatData'
import moment from 'moment'

export const usUserRows = (user) => {
  return {
    id: user?.userId,
    firstname: user?.name ?? 'NA',
    email: user?.email ?? 'NA',
    state: user?.state ?? 'NA',
    city: user?.city ?? 'NA',
    accountStatus: user?.accountStatus === 'Active' ? 'Yes' : 'No',
    isAdminApproved: user?.isAdminApproved === true ? 'Yes' : 'No',
    investmentStatus: user?.investmentStatus ?? 'NA',
    regulationDStatus: user?.isRegDInvestor ?? 'NA',
    propertiesInvested: user?.totalProperties ?? 'NA',
    propertyValue: formatCurrency(user?.propertyValue ?? 0) ?? 'NA',
    encodedSSN: formatSSN(user?.encodedSSN) ?? 'NA',
    phoneNumber: formatPhoneNumber(user?.phoneNumber) ?? 'NA',
    referredBy: user?.referredBy ?? 'NA',
    referredByUser: user?.referredByUser?.name ?? 'NA',
    subscribeForSMS: String(user?.subscribeForSMS) === 'true' ? 'Yes' : 'No' ?? 'NA',
    onboardingStage: String(user?.onboardingStage) ?? 'NA',
    registeredOn: moment(user?.registeredOn ?? 'NA').format('MM/DD/YYYY'),
    lastSession: new Date(+user?.lastSession).toLocaleString() ?? 'NA',
    ipAddress: user?.ipAddress ?? 'NA',
    ipCity: user?.ipCity ?? 'NA',
    ipState: user?.ipState ?? 'NA',
    ipCountry: user?.ipCountry ?? 'NA',
    ipLatitude: user?.ipLatitude ?? 'NA',
    ipLongitude: user?.ipLongitude ?? 'NA',
    Action: user?.isFreeze === true ? 'Yes' : 'No',
  }
}

export const nonUsUserRows = (user) => {
  return {
    is: user?.userId,
    name: user?.name ?? 'NA',
    email: user?.email ?? 'NA',
    countryName: user?.country ?? 'NA',
    phoneNumber: formatPhoneNumber(user?.phoneNumber) ?? 'NA',
    referredBy: user?.referredBy ?? 'NA',
    subscribeForSMS: String(user?.subscribeForSMS) === 'true' ? 'Yes' : 'No' ?? 'NA',
  }
}
